/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UPDATE_ASSOCIATE_BATCH = gql`
    mutation AssociateBatchLazyBindingParentWithProduct(
        $batchLazyBindingParentId: ID!
        $associate: associate!
    ) {
        associateBatchLazyBindingParentWithProduct(
            batchLazyBindingParentId: $batchLazyBindingParentId
            associate: $associate
        ) {
            _id
            description
            dateKey
            product {
              _id
              name
            }
            batch {
              _id
              name
            }
            gtin {
              _id
              name
              item
            }
        }
    }
`;
